var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1808_3486)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FAF7FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1808_3486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84505 6C6.37834 6 6 6.38932 6 6.86957C6 7.34981 6.37834 7.73913 6.84505 7.73913H8.34863C8.47167 7.73913 8.59159 7.77897 8.6914 7.853C8.79121 7.92703 8.86585 8.0315 8.90475 8.15161L11.6909 16.7541C11.8146 17.136 11.8303 17.5473 11.7354 17.9378L11.506 18.8838C11.1694 20.2694 12.2175 21.6522 13.6054 21.6522H23.746C24.2127 21.6522 24.591 21.2629 24.591 20.7826C24.591 20.3024 24.2127 19.913 23.746 19.913H13.6054C13.2764 19.913 13.0651 19.6352 13.1449 19.3067L13.3179 18.5957C13.3473 18.4752 13.4149 18.3683 13.51 18.2918C13.6052 18.2154 13.7224 18.1739 13.8431 18.1739H22.9009C23.2648 18.1741 23.5879 17.9346 23.7031 17.5795L25.956 10.623C26.1385 10.0597 25.7309 9.47799 25.1538 9.47826H11.539C11.416 9.47826 11.2961 9.43843 11.1962 9.3644C11.0964 9.29037 11.0218 9.1859 10.9829 9.06579L10.1823 6.59443C10.0672 6.23926 9.74404 5.9998 9.38019 6H6.84505ZM12.7604 22.5217C11.827 22.5217 11.0703 23.3004 11.0703 24.2609C11.0703 25.2214 11.827 26 12.7604 26C13.6938 26 14.4505 25.2214 14.4505 24.2609C14.4505 23.3004 13.6938 22.5217 12.7604 22.5217ZM22.9009 22.5217C21.9675 22.5217 21.2108 23.3004 21.2108 24.2609C21.2108 25.2214 21.9675 26 22.9009 26C23.8343 26 24.591 25.2214 24.591 24.2609C24.591 23.3004 23.8343 22.5217 22.9009 22.5217Z",
    fill: "#8362E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1808_3486",
    x: -10,
    y: -2,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1808_3486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1808_3486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1808_3486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDriver);
export default __webpack_public_path__ + "static/media/total-driver.f1459d8bd118d43b4ef6a1b202cf086c.svg";
export { ForwardRef as ReactComponent };